import Request from "@/services/westore/http/request";

class Api {
  constructor(baseURL) {
    this.request = new Request(baseURL);
  }

  create(uri, payload) {
    return this.request.post(uri, payload);
  }

  get(uri, params) {
    return this.request.get(uri, params).then(({ data }) => data);
  }

  post(uri, payload) {
    return this.request.post(uri, payload).then(({ data }) => data);
  }

  put(uri, payload) {
    return this.request.put(uri, payload).then(({ data }) => data);
  }
  patch(uri, payload) {
    return this.request.patch(uri, payload).then(({ data }) => data);
  }
  delete(uri, params) {
    return this.request.delete(uri, params).then(({ data }) => data);
  }
  setHeader(key, value) {
    this.request.setHeader(key, value);
  }

  setHeaders(headers) {
    this.request.setHeaders(headers);
    return this;
  }

  withCredentials(bearer_token) {
    this.request.withCredentials(bearer_token);
  }

  hasFiles() {
    this.request.hasFiles();
  }

  blobResponse() {
    this.request.blobResponse();
  }

  getResponse() {
    return this.request.getResponse();
  }
}

export default new Api(process.env.VUE_APP_WESTORE_BASE_URL);
